import React from 'react'

import { Accordion } from 'react-accessible-accordion'
import './faq.css'

import QuestionWithAnswer from './../components/QuestionWithAnswer'

const FAQPage = () => (
  <div className='container'>
    <div className='row col-12'>
      <h2>Frequently Asked Questions</h2>
      <p>Have a question? You can find the answers for the most common questions asked by RePT users.</p>
    </div>

    <div className='row col-12'>
      <Accordion>
        <QuestionWithAnswer question='If I have done less or more reps for a set, how do I log that?'>
        If you keep tapping the set button, the rep count will decrease. Tapping the "+1"-icon that appears when you tap on the set button will increase the rep count.
        </QuestionWithAnswer>
        <QuestionWithAnswer question='How can I customize the Workout Program?'>
          To modify the Workout Program simply tap on the <span className='font-weight-bold'>Settings</span> icon and tap on <span className='font-weight-bold'>Workout Program</span>. <br />
        </QuestionWithAnswer>
        <QuestionWithAnswer question='How can I get a feature request or bug report submitted?'>
          Use the <span className='font-weight-bold'>Send Feedback</span> function in the <span className='font-weight-bold'>RePT</span>App found under <span className='font-weight-bold'>Settings</span> to provide your feedback. You can also contact me at <b><a href="mailto:getreptapp@gmail.com" subject="Help with RePT">getreptapp@gmail.com</a></b>.
        </QuestionWithAnswer>
      </Accordion>
    </div>
  </div>
)

export default FAQPage



// WEBPACK FOOTER //
// ./src/pages/faq.js